import { useNavigate, useLocation } from 'react-router-dom';

import { Box, BodySmall, Modal, BodyBig, Button } from '@parspec/pixel';

interface AccountLockedPopupProps {
    isOpen: boolean;
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const AccountLockedPopup = (props: AccountLockedPopupProps) => {
    const { isOpen, setIsOpen } = props;

    const navigate = useNavigate();
    const location = useLocation();

    const closeModalHandler = () => {
        setIsOpen(() => false);
    };

    const onClickHandler = () => {
        if (location.pathname.startsWith('/login')) {
            closeModalHandler();
        } else {
            navigate('/login');
        }
    };

    return (
        <Box>
            <Modal open={isOpen} footer={''} header={<BodyBig fontWeight={600}>Your Account Has Been Locked</BodyBig>} onClose={closeModalHandler} borderRadius={2}>
                <Box mt={3} width={'406px'} borderRadius={2}>
                    <BodySmall limit={false} color={'text.primary'}>
                        Your account has been temporarily locked for security reasons after multiple unsuccessful authentication code entries.
                    </BodySmall>

                    <BodySmall limit={false} mt={4} color={'text.primary'}>
                        Please contact our team in the Support Chat or at
                        <Box component='span' color='primary.main'> support@parspec.io</Box> to regain access to your account.
                    </BodySmall>

                    <Box mt={4} width="100%">
                        <Button onClick={onClickHandler} fullWidth={true} variant={'outlined'} color={'secondary'}>
                            Back to Login
                        </Button>
                    </Box>
                </Box>
            </Modal>
        </Box>
    );
};
